import { NavItemBaseProps } from 'src/components/nav-section';
import { XBIT_RELAY_HOT_WALLETS_PERMISSION_RESOURCE } from 'src/pages/admin/resources/xbit-relay/hot-wallets/constants';
import { XBIT_RELAY_DEPOSITS_PERMISSION_RESOURCE } from 'src/pages/admin/resources/xbit-relay/deposits/constants';
import { XBIT_RELAY_WITHDRAWALS_PERMISSION_RESOURCE } from 'src/pages/admin/resources/xbit-relay/withdrawals/constants';
import { XBIT_RELAY_TRANSFERS_PERMISSION_RESOURCE } from 'src/pages/admin/resources/xbit-relay/transfers/constants';
import { XBIT_RELAY_TRANSACTION_RESCAN_PERMISSION_RESOURCE } from 'src/pages/admin/resources/xbit-relay/transaction-rescan/constants';
import { XBIT_RELAY_REBALANCES_PERMISSION_RESOURCE } from 'src/pages/admin/resources/xbit-relay/hot-wallet-balancer/constants';
import { XBIT_RELAY_SWEEP_PERMISSION_RESOURCE } from 'src/pages/admin/resources/xbit-relay/sweep-monitor/constants';
import { XBIT_RELAY_SWEEP_HISTORY_PERMISSION_RESOURCE } from 'src/pages/admin/resources/xbit-relay/sweep-history/constants';
import { XBIT_RELAY_DEPOSIT_WALLETS_PERMISSION_RESOURCE } from 'src/pages/admin/resources/xbit-relay/deposit-wallets/constants';
import { XBIT_RELAY_WITHDRAWAL_PROVIDER_CONFIGS_PERMISSION_RESOURCE } from 'src/pages/admin/resources/xbit-relay/withdrawal-provider-configs/constants';
import { XBIT_RELAY_PROVIDER_AUDIT_PERMISSION_RESOURCE } from 'src/pages/admin/resources/xbit-relay/provider-audit/constants';
import { XPX_PERPS_WITHDRAWAL_PERMISSION_RESOURCE } from 'src/pages/admin/resources/xpx-perps-withdrawal/constants';
import { DASHBOARD_PERMISSION_RESOURCE as VAULT_DASHBOARD_PERMISSION_RESOURCE } from 'src/pages/admin/resources/vault/dashboard/constants';
import { VAULT_PARAMS_PERMISSION_RESOURCE } from 'src/pages/admin/resources/vault/params/constants';
import { OFFICIAL_VAULTS_PERMISSION_RESOURCE } from 'src/pages/admin/resources/vault/official-vaults/constants';
import { VAULTS_PERMISSION_RESOURCE } from 'src/pages/admin/resources/vault/vaults/constants';
import { INVESTORS_PERMISSION_RESOURCE } from 'src/pages/admin/resources/vault/investors/constants';
import { RECORDS_PERMISSION_RESOURCE } from 'src/pages/admin/resources/vault/records/constants';
import {
  OPERATIONS_PERMISSION_RESOURCE,
  SIGNERS_PERMISSION_RESOURCE,
} from 'src/pages/admin/resources/vault/operations/constants';
import { RECONCILIATION_PERMISSION_RESOURCE } from 'src/pages/admin/resources/vault/reconciliation/constants';
import { paths } from 'src/routes/paths';
import { ICONS } from './icons';
import { featureFlags } from 'src/configs/feature-flags.config';

/** An entry shown to a role holding `resource` OR any of `alsoResources` (read): Operations is also the home of Waiting for signers. */
export type MenuItem = NavItemBaseProps & { alsoResources?: string[] };

export interface LeftMenuItem {
  subheader?: string;
  items: MenuItem[];
}

export const adminLeftMenu: LeftMenuItem[] = [
  // 01 · Data Overview
  {
    subheader: 'resource.sectionDataOverview',
    items: [
      {
        title: 'resource.dashboard',
        path: paths.dashboard.root,
        icon: ICONS.dashboard,
        resource: 'dashboard',
        action: 'read',
      },
      {
        title: 'resource.dashboard-v2',
        path: paths.dashboard.v2.root,
        icon: ICONS.dashboard,
        resource: 'perpetuals',
        action: 'read',
      },
      {
        title: 'resource.dashboard-v3',
        path: paths.dashboard.v3.root,
        icon: ICONS.dashboard,
        resource: 'dashboard-v3',
        action: 'read',
      },
      {
        title: 'resource.analytics',
        path: paths.dashboard.analytics,
        icon: ICONS.dashboard,
        resource: 'analytics',
        action: 'read',
      },
      {
        title: 'resource.perpetualTrading',
        path: paths.dashboard.perpetualTrading.root,
        icon: ICONS.analytics,
        resource: 'perpetual-trading',
        action: 'read',
      },
      {
        title: 'resource.predictionTrading',
        path: paths.dashboard.predictionTrading.root,
        icon: ICONS.analytics,
        resource: 'prediction-builder-trade-stats',
        action: 'read',
      },
    ],
  },

  // 02 · User Center
  {
    subheader: 'resource.sectionUserCenter',
    items: [
      {
        title: 'resource.userInfo',
        path: paths.userManagement.userInfo.root,
        icon: ICONS.userInfo,
        resource: 'user-info',
        action: 'read',
      },
      {
        title: 'resource.tradingRetention',
        path: paths.userManagement.tradingRetention.root,
        icon: ICONS.userInfo,
        resource: 'trading-retention',
        action: 'read',
      },
      {
        title: 'resource.referralRanking',
        path: paths.userManagement.referralRanking.root,
        icon: ICONS.userInfo,
        resource: 'referral-ranking',
        action: 'read',
      },
      ...(featureFlags.feedback
        ? [
            {
              title: 'resource.userFeedback',
              path: paths.userManagement.userFeedback.root,
              icon: ICONS.feedback,
              resource: 'user-feedback',
              action: 'read',
            },
          ]
        : []),
      {
        title: 'resource.userRole',
        path: paths.userRole.userRole.root,
        resource: 'user-role',
        action: 'read',
        icon: ICONS.job,
      },
    ],
  },

  // 03 · Activity Operations
  {
    subheader: 'resource.sectionActivityOps',
    items: [
      // General Activities
      {
        title: 'resource.groupGeneralActivities',
        path: '#',
        icon: ICONS.menuItem,
        children: [
          {
            title: 'resource.activityUserManagement',
            path: '#',
            children: [
              {
                title: 'resource.activityUserActivityStats',
                path: paths.activity.userActivityStats.root,
                resource: 'activity-user-stats',
                action: 'read',
              },
            ],
          },
          {
            title: 'resource.activityTaskManagement',
            path: '#',
            children: [
              {
                title: 'resource.activityTaskCompletionStats',
                path: paths.activity.taskCompletionStats.root,
                resource: 'activity-task-completion',
                action: 'read',
              },
              {
                title: 'resource.activityTaskCategories',
                path: paths.activity.taskCategories.root,
                resource: 'activity-task-category',
                action: 'read',
              },
              {
                title: 'resource.activityTasks',
                path: paths.activity.tasks.root,
                resource: 'activity-task',
                action: 'read',
              },
            ],
          },
          {
            title: 'resource.activityTierBenefitManagement',
            path: '#',
            children: [
              {
                title: 'resource.activityTierBenefitDistribution',
                path: paths.activity.tierDistribution.root,
                resource: 'activity-tier-distribution',
                action: 'read',
              },
              {
                title: 'resource.activityTierBenefits',
                path: paths.activity.tierBenefits.root,
                resource: 'activity-tier-benefit',
                action: 'read',
              },
            ],
          },
        ],
      },
      // Blind Box
      {
        title: 'resource.blindBox',
        path: '#',
        icon: ICONS.menuItem,
        children: [
          {
            title: 'module.blindBox.overviewData',
            path: paths.blindBox.overview.root,
            resource: 'bb-overview',
            action: 'read',
          },
          {
            title: 'module.blindBox.manualDistribution',
            path: paths.blindBox.manual_distribution.root,
            resource: 'bb-manual-distribution',
            action: 'read',
          },
          {
            title: 'module.blindBox.leaderboard',
            path: paths.blindBox.leaderboard.root,
            resource: 'bb-leaderboard',
            action: 'read',
          },
          {
            title: 'module.blindBox.banTitle',
            path: paths.blindBox.banned_users.root,
            resource: 'bb-leaderboard',
            action: 'read',
          },
          {
            title: 'module.blindBox.sectionActivityConfig',
            path: '#',
            children: [
              {
                title: 'module.blindBox.activityBasic',
                path: paths.blindBox.activity_basic.root,
                resource: 'bb-activity-basic',
                action: 'read',
              },
              {
                title: 'module.blindBox.luckyWheel',
                path: paths.blindBox.lucky_wheel.root,
                resource: 'bb-lucky-wheel',
                action: 'read',
              },
              {
                title: 'module.blindBox.blindBoxProbability',
                path: paths.blindBox.blind_box_probability.root,
                resource: 'bb-probability',
                action: 'read',
              },
              {
                title: 'module.blindBox.tasks',
                path: paths.blindBox.tasks.root,
                resource: 'bb-tasks',
                action: 'read',
              },
              {
                title: 'module.blindBox.tradingTiers',
                path: paths.blindBox.trading_tiers.root,
                resource: 'bb-trading-tiers',
                action: 'read',
              },
            ],
          },
          {
            title: 'module.blindBox.sectionGrowthLottery',
            path: '#',
            children: [
              {
                title: 'module.blindBox.levelSystem',
                path: paths.blindBox.level_system.root,
                resource: 'bb-level-system',
                action: 'read',
              },
              {
                title: 'module.blindBox.holidayLottery',
                path: paths.blindBox.holiday_lottery.root,
                resource: 'bb-holiday-lottery',
                action: 'read',
              },
              {
                title: 'module.blindBox.holidayLotteryConfig',
                path: paths.blindBox.holiday_lottery_config.root,
                resource: 'bb-holiday-lottery-config',
                action: 'read',
              },
            ],
          },
          {
            title: 'module.blindBox.sectionContent',
            path: '#',
            children: [
              {
                title: 'module.blindBox.winnersTicker',
                path: paths.blindBox.winners_ticker.root,
                resource: 'bb-winners-ticker',
                action: 'read',
              },
              {
                title: 'module.blindBox.winRecords',
                path: paths.blindBox.win_records.root,
                resource: 'bb-win-records',
                action: 'read',
              },
              {
                title: 'module.blindBox.openSessions',
                path: paths.blindBox.open_sessions.root,
                resource: 'bb-open-sessions',
                action: 'read',
              },
              {
                title: 'module.blindBox.taskClaims',
                path: paths.blindBox.task_claims.root,
                resource: 'bb-task-claims',
                action: 'read',
              },
              {
                title: 'module.blindBox.lotteryTickets',
                path: paths.blindBox.lottery_tickets.root,
                resource: 'bb-lottery-tickets',
                action: 'read',
              },
              {
                title: 'module.blindBox.userXpHistory',
                path: paths.blindBox.user_xp_history.root,
                resource: 'bb-user-xp-history',
                action: 'read',
              },
              {
                title: 'module.blindBox.spinBoxGrantHistory',
                path: paths.blindBox.spin_box_grant_history.root,
                resource: 'bb-spin-box-grants',
                action: 'read',
              },
              {
                title: 'module.blindBox.userRewardSummary',
                path: paths.blindBox.user_reward_summary.root,
                resource: 'bb-user-reward-summary',
                action: 'read',
              },
              {
                title: 'module.blindBox.rewardFeed',
                path: paths.blindBox.reward_feed.root,
                resource: 'bb-reward-feed',
                action: 'read',
              },
              {
                title: 'module.blindBox.rewardFeedUsdc',
                path: paths.blindBox.reward_feed_usdc.root,
                resource: 'bb-reward-feed-usdc',
                action: 'read',
              },
              {
                title: 'module.blindBox.socialFollowers',
                path: paths.blindBox.social_followers.root,
                resource: 'bb-social-followers',
                action: 'read',
              },
            ],
          },
          {
            title: 'module.blindBox.sectionWithdrawal',
            path: '#',
            children: [
              {
                title: 'module.blindBox.withdrawConfig',
                path: paths.blindBox.withdraw_config.root,
                resource: 'bb-withdraw-config',
                action: 'read',
              },
              {
                title: 'module.blindBox.withdrawRecords',
                path: paths.blindBox.withdrawals.root,
                resource: 'bb-withdrawals',
                action: 'read',
              },
            ],
          },
        ],
      },
      // Trading Room Admin V1
      {
        title: 'resource.socialTrading',
        path: '#',
        icon: ICONS.menuItem,
        children: [
          {
            title: 'module.socialTrading.groupOverview',
            path: '#',
            children: [
              {
                title: 'module.socialTrading.workbench',
                path: paths.socialTrading.workbench.root,
                resource: 'st-workbench',
                action: 'read',
              },
            ],
          },
          {
            title: 'module.socialTrading.groupIntel',
            path: '#',
            children: [
              {
                title: 'module.socialTrading.intelList',
                path: paths.socialTrading.intel.root,
                resource: 'st-intel',
                action: 'read',
              },
              {
                title: 'module.socialTrading.intelCategories',
                path: paths.socialTrading.intelCategories.root,
                resource: 'st-intel-categories',
                action: 'read',
              },
            ],
          },
          {
            title: 'module.socialTrading.groupPermissions',
            path: '#',
            children: [
              {
                title: 'module.socialTrading.accounts',
                path: paths.socialTrading.accounts.root,
                resource: 'st-accounts',
                action: 'read',
              },
              {
                title: 'module.socialTrading.users',
                path: paths.socialTrading.users.root,
                resource: 'st-users',
                action: 'read',
              },
            ],
          },
          {
            title: 'module.socialTrading.groupChat',
            path: '#',
            children: [
              {
                title: 'module.socialTrading.rooms',
                path: paths.socialTrading.rooms.root,
                resource: 'st-rooms',
                action: 'read',
              },
              {
                title: 'module.socialTrading.roomMembers',
                path: paths.socialTrading.roomMembers.root,
                resource: 'st-room-members',
                action: 'read',
              },
              {
                title: 'module.socialTrading.messageStats',
                path: paths.socialTrading.messageStats.root,
                resource: 'social-trading-message-stats',
                action: 'read',
              },
            ],
          },
          {
            title: 'module.socialTrading.groupStrategy',
            path: '#',
            children: [
              {
                title: 'module.socialTrading.agents',
                path: paths.socialTrading.agents.root,
                resource: 'st-agents',
                action: 'read',
              },
              {
                title: 'module.socialTrading.agentsConfig',
                path: paths.socialTrading.agentsConfig.root,
                resource: 'st-agents-config',
                action: 'read',
              },
              {
                title: 'module.socialTrading.signals',
                path: paths.socialTrading.signals.root,
                resource: 'st-signals',
                action: 'read',
              },
            ],
          },
          {
            title: 'module.socialTrading.groupRedpacket',
            path: '#',
            children: [
              {
                title: 'module.socialTrading.redpacketConfig',
                path: paths.socialTrading.redpacketConfig.root,
                resource: 'st-redpacket-config',
                action: 'read',
              },
              {
                title: 'module.socialTrading.redpacketPackets',
                path: paths.socialTrading.redpacketPackets.root,
                resource: 'st-redpacket-packets',
                action: 'read',
              },
              {
                title: 'module.socialTrading.redpacketLedgerEntries',
                path: paths.socialTrading.redpacketLedgerEntries.root,
                resource: 'st-ledger-entries',
                action: 'read',
              },
              {
                title: 'module.socialTrading.redpacketWithdrawals',
                path: paths.socialTrading.redpacketWithdrawals.root,
                resource: 'st-redpacket-withdrawals',
                action: 'read',
              },
              {
                title: 'module.socialTrading.redpacketBalanceReclaim',
                path: paths.socialTrading.redpacketBalanceReclaim.root,
                resource: 'st-redpacket-balances',
                action: 'update',
              },
            ],
          },
          {
            title: 'module.socialTrading.groupPool',
            path: '#',
            children: [
              {
                title: 'module.socialTrading.poolConfig',
                path: paths.socialTrading.poolConfig.root,
                resource: 'st-pool-config',
                action: 'read',
              },
              {
                title: 'module.socialTrading.roomPools',
                path: paths.socialTrading.pools.root,
                resource: 'st-room-pools',
                action: 'read',
              },
              {
                title: 'module.socialTrading.poolDashboard',
                path: paths.socialTrading.poolDashboard.root,
                resource: 'st-pool-dashboard',
                action: 'read',
              },
              {
                title: 'module.socialTrading.poolEnrollments',
                path: paths.socialTrading.poolEnrollments.root,
                resource: 'st-pool-enrollments',
                action: 'read',
              },
              {
                title: 'module.socialTrading.poolContributions',
                path: paths.socialTrading.poolContributions.root,
                resource: 'st-pool-contributions',
                action: 'read',
              },
              {
                title: 'module.socialTrading.poolRewardClaims',
                path: paths.socialTrading.poolRewardClaims.root,
                resource: 'social-trading-settlement',
                action: 'read',
              },
            ],
          },
          {
            title: 'module.socialTrading.groupControl',
            path: '#',
            children: [
              {
                title: 'module.socialTrading.systemConfigs',
                path: paths.socialTrading.systemConfigs.root,
                resource: 'st-system-configs',
                action: 'read',
              },
              {
                title: 'module.socialTrading.avatarDefaults',
                path: paths.socialTrading.avatarDefaults.root,
                resource: 'st-avatar-defaults',
                action: 'read',
              },
              {
                title: 'module.socialTrading.audit',
                path: paths.socialTrading.audit.root,
                resource: 'social-trading-audit',
                action: 'read',
              },
            ],
          },
        ],
      },
      // Special Campaigns
      {
        title: 'resource.groupSpecialCampaigns',
        path: '#',
        icon: ICONS.menuItem,
        children: [
          // World Cup
          {
            title: 'resource.worldCup',
            path: '#',
            children: [
              {
                title: 'resource.worldCupOverview',
                path: paths.worldCup.overview.root,
                resource: 'world-cup-overview',
                action: 'read',
              },
              {
                title: 'resource.worldCupMatchData',
                path: paths.worldCup.matchData.root,
                resource: 'world-cup-match-data',
                action: 'read',
              },
              {
                title: 'resource.worldCupFocusMatchConfig',
                path: paths.worldCup.focusMatchConfig.root,
                resource: 'world-cup-focus-match',
                action: 'read',
              },
              {
                title: 'resource.worldCupGrandPrixConfig',
                path: paths.worldCup.grandPrixConfig.root,
                resource: 'world-cup-grand-prix',
                action: 'read',
              },
              {
                title: 'resource.worldCupLeaderboardConfig',
                path: paths.worldCup.leaderboardConfig.root,
                resource: 'world-cup-leaderboard',
                action: 'read',
              },
              {
                title: 'resource.worldCupPredictionVoucherRule',
                path: paths.worldCup.predictionVoucherRule.root,
                resource: 'world-cup-prediction-voucher',
                action: 'read',
              },
              {
                title: 'resource.worldCupManualIssue',
                path: paths.worldCup.manualIssue.root,
                resource: 'world-cup-voucher-manual-issue',
                action: 'read',
              },
              {
                title: 'resource.worldCupUserVouchers',
                path: paths.worldCup.userVouchers.root,
                resource: 'world-cup-user-vouchers',
                action: 'read',
              },
              {
                title: 'resource.worldCupWhitelist',
                path: paths.worldCup.whitelist.root,
                resource: 'world-cup-whitelist',
                action: 'read',
              },
              {
                title: 'resource.worldCupBreakingEvents',
                path: paths.worldCup.breakingEvents.root,
                resource: 'world-cup-custom-breaking',
                action: 'read',
              },
              {
                title: 'resource.worldCupEmergencyFuse',
                path: paths.worldCup.emergencyFuse.root,
                resource: 'world-cup-emergency-fuse',
                action: 'read',
              },
              {
                title: 'resource.worldCupFaq',
                path: paths.worldCup.faq.root,
                resource: 'world-cup-copy-faq',
                action: 'read',
              },
            ],
          },
          // Prediction Leverage Whitelist
          {
            title: 'resource.groupPredictionWhitelist',
            path: '#',
            children: [
              {
                title: 'whitelist.candidate.title',
                path: paths.whitelist.candidate.root,
                resource: 'whitelist-candidate',
                action: 'read',
              },
              {
                title: 'whitelist.reward.title',
                path: paths.whitelist.reward.root,
                resource: 'whitelist-reward-config',
                action: 'read',
              },
              {
                title: 'FAQ',
                path: paths.whitelist.faq.root,
                resource: 'whitelist-faq',
                action: 'read',
              },
              {
                title: 'whitelist.earlyBird.title',
                path: paths.whitelist.early_bird.root,
                resource: 'whitelist-early-bird',
                action: 'read',
              },
              {
                title: 'whitelist.leaderboard.title',
                path: paths.whitelist.leaderboard.root,
                resource: 'whitelist-leaderboard',
                action: 'read',
              },
              {
                title: 'whitelist.inviteData.title',
                path: paths.whitelist.invite.root,
                resource: 'whitelist-invite',
                action: 'read',
              },
              {
                title: 'whitelist.manually.title',
                path: paths.whitelist.manually.root,
                resource: 'whitelist-manually',
                action: 'read',
              },
              {
                title: 'whitelist.redeem.menuTitle',
                path: paths.whitelist.redeem.root,
                resource: 'whitelist-redeem',
                action: 'read',
              },
              {
                title: 'whitelist.users.title',
                path: paths.whitelist.users.root,
                resource: 'whitelist-users',
                action: 'read',
              },
              {
                title: 'whitelist.eventParticipants.title',
                path: paths.whitelist.eventParticipants.root,
                resource: 'whitelist-event-participants',
                action: 'read',
              },
            ],
          },
          // Bold Prediction Campaign
          {
            title: 'module.boldPredictionCampaign.title',
            path: '#',
            children: [
              {
                title: 'module.boldPredictionCampaign.configs',
                path: paths.boldPredictionCampaign.configs.root,
                resource: 'world-cup-leverage',
                action: 'read',
              },
              {
                title: 'module.boldPredictionCampaign.stats.title',
                path: paths.boldPredictionCampaign.stats.root,
                resource: 'world-cup-leverage-stats',
                action: 'read',
              },
            ],
          },
        ],
      },
    ],
  },

  // 04 · Agent & Incentive
  {
    subheader: 'resource.sectionAgentIncentive',
    items: [
      {
        title: 'resource.agentLevel',
        path: paths.agentRebate.agents.root,
        resource: 'agents',
        action: 'read',
        icon: ICONS.job,
      },
      {
        title: 'resource.agentInfo',
        path: paths.agentRebate.agentInfo.root,
        resource: 'agent-info',
        action: 'read',
        icon: ICONS.user,
      },
      {
        title: 'resource.unlimitedAgents',
        path: paths.agentRebate.unlimitedAgents.root,
        resource: 'unlimited-agents',
        action: 'read',
        icon: ICONS.banking,
      },
      {
        title: 'resource.rewardClaims',
        path: paths.agentRebate.rewardClaims.root,
        resource: 'agent-reward-claims',
        action: 'read',
        icon: ICONS.invoice,
      },
      {
        title: 'resource.agentRewardRules',
        path: paths.agentRebate.rewardRules.root,
        resource: 'agent-reward-rules',
        action: 'read',
        icon: ICONS.withdraw,
      },
      {
        title: 'resource.inviteCodes',
        path: '#',
        icon: ICONS.roles,
        children: [
          {
            title: 'resource.inviteCodesItem',
            path: paths.inviteCodes.codes.root,
            resource: 'invite-codes',
            action: 'read',
            roles: ['*'],
          },
          {
            title: 'resource.inviteCodesConfig',
            path: paths.inviteCodes.config.root,
            resource: 'invite-beta-code-config',
            action: 'read',
            roles: ['*'],
          },
        ],
      },
    ],
  },

  // 05 · Content Operations
  {
    subheader: 'resource.sectionContentOps',
    items: [
      {
        title: 'resource.banners',
        path: paths.banners.codes.root,
        resource: 'banners',
        action: 'read',
        icon: ICONS.menuItem,
        roles: ['*'],
      },
      {
        title: 'resource.smallBanners',
        path: paths.smallBanners.codes.root,
        resource: 'small-banners',
        action: 'read',
        icon: ICONS.menuItem,
        roles: ['*'],
      },
      {
        title: 'resource.announcementPopup',
        path: paths.publishing.announcementPopup.codes.root,
        resource: 'maintenance-banners',
        action: 'read',
        icon: ICONS.menuItem,
        roles: ['*'],
      },
      {
        title: 'resource.linkConfig',
        path: paths.publishing.linkConfig.codes.root,
        resource: 'link-configs',
        action: 'read',
        icon: ICONS.menuItem,
        roles: ['*'],
      },
      {
        title: 'resource.cdnUpload',
        path: paths.publishing.cdnUpload.codes.root,
        resource: 'cdn-uploads',
        action: 'read',
        icon: ICONS.menuItem,
        roles: ['*'],
      },
      {
        title: 'resource.coinImages',
        path: paths.publishing.coinImages.codes.root,
        resource: 'cdn-coin-images',
        action: 'read',
        icon: ICONS.menuItem,
        roles: ['*'],
      },
      {
        title: 'resource.coinSymbols',
        path: paths.publishing.coinSymbols.codes.root,
        resource: 'cdn-coin-symbols',
        action: 'read',
        icon: ICONS.menuItem,
      },
      {
        title: 'module.hot-search.title',
        path: paths.hotSearch.codes.root,
        resource: 'hotSearching',
        action: 'read',
        icon: ICONS.menuItem,
        roles: ['*'],
      },
      {
        title: 'resource.hotSymbols',
        path: paths.hotSymbols.codes.root,
        resource: 'hot-symbols',
        action: 'read',
        icon: ICONS.menuItem,
        roles: ['*'],
      },
    ].map((item) => ({
      ...item,
      roles: ['*'],
    })),
  },

  // 06 · Product Config
  {
    subheader: 'resource.sectionProductConfig',
    items: [
      // MEME
      {
        title: 'resource.meme',
        path: '#',
        icon: ICONS.menuItem,
        children: [
          {
            title: 'resource.home',
            path: '#',
            children: [
              {
                title: 'resource.category',
                path: paths.dashboard.home.categories.root,
                resource: 'categories',
                action: 'read',
              },
            ],
          },
          {
            title: 'resource.token',
            path: '#',
            children: [
              {
                title: 'resource.tokenMetadata',
                path: paths.dashboard.tokenMetadata.root,
                resource: 'token-metadatas',
                action: 'read',
              },
              {
                title: 'resource.tokenOnchainInfo',
                path: paths.dashboard.tokenOnchainInfo.root,
                resource: 'onchain-infos',
                action: 'read',
              },
            ],
          },
          {
            title: 'resource.trading',
            path: '#',
            children: [
              {
                title: 'resource.feeManagementScreen',
                path: paths.dashboard.tradingFeeManagementScreen.root,
                resource: 'fee-management',
                action: 'read',
              },
              {
                title: 'resource.token-X-Stock',
                path: paths.dashboard.tokenStock.root,
                resource: 'x-stocks',
                action: 'read',
              },
              {
                title: 'resource.trandingToken',
                path: paths.dashboard.config.trandingToken.root,
                resource: 'tranding-tokens',
                action: 'read',
              },
              {
                title: 'resource.searchPlaceholder',
                path: paths.dashboard.config.searchPlaceholder.root,
                resource: 'search-placeholders',
                action: 'read',
              },
              {
                title: 'resource.transactions',
                path: paths.dashboard.transactions.root,
                resource: 'transactions',
                action: 'read',
              },
            ],
          },
        ],
      },
      // Prediction
      {
        title: 'resource.prediction',
        path: '#',
        icon: ICONS.settings,
        children: [
          {
            title: 'module.prediction.system-configs.title',
            path: paths.prediction.system_configs.root,
            resource: 'prediction-system-configs',
            action: 'read',
          },
          {
            title: 'resource.predictionFeaturedMarkets',
            path: paths.prediction.featured_markets.root,
            resource: 'prediction-admin-events',
            action: 'read',
          },
        ],
      },
      // Swap
      {
        title: 'resource.swap',
        path: '#',
        icon: ICONS.invoice,
        children: [
          {
            title: 'resource.transaction',
            path: '#',
            children: [
              {
                title: 'resource.dashboard',
                path: paths.swap.transaction.dashboard.root,
                resource: 'swap-dashboard',
                action: 'read',
              },
              {
                title: 'resource.routingStatistics',
                path: paths.swap.transaction.routingStatistics.root,
                resource: 'swap-routing-statistics',
                action: 'read',
              },
              {
                title: 'resource.tokenRouteStatistics',
                path: paths.swap.transaction.tokenRouteStatistics.root,
                resource: 'swap-token-route-statistics',
                action: 'read',
              },
            ],
          },
          {
            title: 'resource.swapUser',
            path: '#',
            children: [
              {
                title: 'resource.swapUserRanking',
                path: paths.swap.user.ranking.root,
                resource: 'swap-user-ranking',
                action: 'read',
              },
              {
                title: 'resource.swapUserDetail',
                path: paths.swap.user.detail.root,
                resource: 'swap-user-detail',
                action: 'read',
              },
              {
                title: 'module.relay-deposit.title',
                path: paths.relayDeposit.codes.root,
                resource: 'relay',
                action: 'read',
              },
            ],
          },
          {
            title: 'resource.swapChainToken',
            path: '#',
            children: [
              {
                title: 'resource.swapChainsManagement',
                path: paths.swap.chainToken.chainsManagement.root,
                resource: 'swap-chains',
                action: 'read',
              },
              {
                title: 'resource.swapTokensManagement',
                path: paths.swap.chainToken.tokensManagement.root,
                resource: 'swap-tokens',
                action: 'read',
              },
            ],
          },
          {
            title: 'resource.swapConfig',
            path: '#',
            children: [
              {
                title: 'resource.swapConfigFee',
                path: paths.swap.config.fee.root,
                resource: 'swap-fee-config',
                action: 'read',
              },
              {
                title: 'resource.swapConfigRango',
                path: paths.swap.config.rango.root,
                resource: 'swap-rango-config',
                action: 'read',
              },
            ],
          },
          {
            title: 'resource.xbitRelay',
            path: '#',
            children: [
              {
                title: 'resource.xbitRelayHotWalletBalancer',
                path: paths.dashboard.xbitRelay.hotWalletBalancer.root,
                icon: ICONS.wallet,
                resource: XBIT_RELAY_REBALANCES_PERMISSION_RESOURCE,
                action: 'read',
              },
              {
                title: 'resource.xbitRelayHotWallets',
                path: paths.dashboard.xbitRelay.hotWallets.root,
                resource: XBIT_RELAY_HOT_WALLETS_PERMISSION_RESOURCE,
                action: 'read',
              },
              {
                title: 'resource.xbitRelayDeposits',
                path: paths.dashboard.xbitRelay.deposits.root,
                resource: XBIT_RELAY_DEPOSITS_PERMISSION_RESOURCE,
                action: 'read',
              },
              {
                title: 'resource.xbitRelayWithdrawals',
                path: paths.dashboard.xbitRelay.withdrawals.root,
                resource: XBIT_RELAY_WITHDRAWALS_PERMISSION_RESOURCE,
                action: 'read',
              },
              {
                title: 'resource.xbitRelayWithdrawalProviderConfigs',
                path: paths.dashboard.xbitRelay.withdrawalProviderConfigs.root,
                resource: XBIT_RELAY_WITHDRAWAL_PROVIDER_CONFIGS_PERMISSION_RESOURCE,
                action: 'read',
                roles: ['admin'],
              },
              {
                title: 'resource.xbitRelayTransactionRescan',
                path: paths.dashboard.xbitRelay.transactionRescan.root,
                icon: ICONS.order,
                resource: XBIT_RELAY_TRANSACTION_RESCAN_PERMISSION_RESOURCE,
                action: 'read',
                roles: ['admin'],
              },
              {
                title: 'resource.xbitRelayTransfers',
                path: paths.dashboard.xbitRelay.transfers.root,
                icon: ICONS.withdraw,
                resource: XBIT_RELAY_TRANSFERS_PERMISSION_RESOURCE,
                action: 'read',
              },
              {
                title: 'resource.xbitRelaySweepMonitor',
                path: paths.dashboard.xbitRelay.sweepMonitor.root,
                icon: ICONS.wallet,
                resource: XBIT_RELAY_SWEEP_PERMISSION_RESOURCE,
                action: 'read',
              },
              {
                title: 'resource.xbitRelaySweepHistory',
                path: paths.dashboard.xbitRelay.sweepHistory.root,
                icon: ICONS.cashOut,
                resource: XBIT_RELAY_SWEEP_HISTORY_PERMISSION_RESOURCE,
                action: 'read',
              },
              {
                title: 'resource.xbitRelayDepositWallets',
                path: paths.dashboard.xbitRelay.depositWallets.root,
                icon: ICONS.wallet,
                resource: XBIT_RELAY_DEPOSIT_WALLETS_PERMISSION_RESOURCE,
                action: 'read',
              },
              {
                title: 'resource.xbitRelayProviderAudit',
                path: paths.dashboard.xbitRelay.providerAudit.root,
                icon: ICONS.security,
                resource: XBIT_RELAY_PROVIDER_AUDIT_PERMISSION_RESOURCE,
                action: 'read',
              },
              {
                title: 'resource.xpxPerpsChainConfigs',
                path: paths.dashboard.xpxPerpsChainConfigs.root,
                resource: 'xpx-perps:chain-config',
                action: 'read',
              },
              {
                title: 'resource.xpxPerpsTokenConfigs',
                path: paths.dashboard.xpxPerpsTokenConfigs.root,
                resource: 'xpx-perps:token-config',
                action: 'read',
              },
            ],
          },
        ],
      },      // Vault — one flat list, most-used first (XBIT-4950). The shared nav shows icons only at depth 1 and truncates labels
      // at depth 3, so nested groups were worse than this list.
      {
        title: 'resource.vault',
        path: '#',
        icon: ICONS.banking,
        // opt-in: the nav shows icons at depth 1 only, so the Vault entries ask for theirs (no other product's submenu changes)
        childIcons: true,
        children: [
          {
            title: 'resource.vaultOperations',
            tooltip: 'resource.vaultOperationsCaption',
            icon: ICONS.kanban,
            path: paths.dashboard.vaultOperations.root,
            resource: OPERATIONS_PERMISSION_RESOURCE,
            alsoResources: [SIGNERS_PERMISSION_RESOURCE],
            action: 'read',
          },
          {
            title: 'resource.vaultDashboard',
            tooltip: 'resource.vaultDashboardCaption',
            icon: ICONS.dashboard,
            path: paths.dashboard.vaultDashboard.root,
            resource: VAULT_DASHBOARD_PERMISSION_RESOURCE,
            action: 'read',
          },
          {
            title: 'resource.vaultVaults',
            tooltip: 'resource.vaultVaultsCaption',
            icon: ICONS.wallet,
            path: paths.dashboard.vaultVaults.root,
            resource: VAULTS_PERMISSION_RESOURCE,
            action: 'read',
          },
          {
            title: 'resource.vaultOfficialVaults',
            tooltip: 'resource.vaultOfficialVaultsCaption',
            icon: ICONS.invoice,
            path: paths.dashboard.vaultOfficialVaults.root,
            resource: OFFICIAL_VAULTS_PERMISSION_RESOURCE,
            action: 'read',
          },
          {
            title: 'resource.vaultInvestors',
            tooltip: 'resource.vaultInvestorsCaption',
            icon: ICONS.user,
            path: paths.dashboard.vaultInvestors.root,
            resource: INVESTORS_PERMISSION_RESOURCE,
            action: 'read',
          },
          {
            title: 'resource.vaultRecords',
            tooltip: 'resource.vaultRecordsCaption',
            icon: ICONS.subscription,
            path: paths.dashboard.vaultRecords.root,
            resource: RECORDS_PERMISSION_RESOURCE,
            action: 'read',
          },
          {
            title: 'resource.vaultReconciliation',
            tooltip: 'resource.vaultReconciliationCaption',
            icon: ICONS.security,
            path: paths.dashboard.vaultReconciliation.root,
            resource: RECONCILIATION_PERMISSION_RESOURCE,
            action: 'read',
          },
          {
            title: 'resource.vaultParams',
            tooltip: 'resource.vaultParamsCaption',
            icon: ICONS.parameter,
            path: paths.dashboard.vaultParams.root,
            resource: VAULT_PARAMS_PERMISSION_RESOURCE,
            action: 'read',
          },
        ],
      },

      // Perps Core
      {
        title: 'resource.perpsCore',
        path: '#',
        icon: ICONS.analytics,
        children: [
          {
            title: 'resource.groupPerpsOperations',
            path: '#',
            children: [
              {
                title: 'resource.xpxPerpsWithdrawal',
                path: paths.dashboard.xpxPerpsWithdrawal.root,
                resource: XPX_PERPS_WITHDRAWAL_PERMISSION_RESOURCE,
                action: 'read',
              },
            ],
          },
        ],
      },
      // Perps V1 — dynamic market views (hypertrader-go)
      {
        title: 'resource.perpsV1',
        path: '#',
        icon: ICONS.analytics,
        children: [
          {
            title: 'resource.perpsV1Navigation',
            path: paths.dashboard.perpsV1Views.root,
            resource: 'perps-v1:views',
            action: 'read',
          },
          {
            title: 'resource.perpsV1Pins',
            path: paths.dashboard.perpsV1Pins.root,
            resource: 'perps-v1:pins',
            action: 'read',
          },
          {
            title: 'resource.perpsV1Sectors',
            path: paths.dashboard.perpsV1Sectors.root,
            resource: 'perps-v1:sectors',
            action: 'read',
          },
          {
            title: 'resource.perpsV1Symbols',
            path: paths.dashboard.perpsV1Symbols.root,
            resource: 'perps-v1:symbols',
            action: 'read',
          },
          {
            title: 'resource.perpsV1Presets',
            path: paths.dashboard.perpsV1Presets.root,
            resource: 'perps-v1:favorite-presets',
            action: 'read',
          },
        ],
      },
    ],
  },

  // 07 · Finance & Risk
  {
    subheader: 'resource.sectionFinanceRisk',
    items: [
      {
        title: 'resource.transactionSigning',
        path: paths.finance.sign.root,
        resource: 'signTransactions',
        action: 'read',
        icon: ICONS.roles,
        roles: ['*'],
      },
      {
        title: 'resource.withdraw',
        path: paths.finance.withdraw.root,
        resource: 'withdraw',
        action: 'read',
        icon: ICONS.withdraw,
        roles: ['*'],
      },
      {
        title: 'resource.financeTransfers',
        path: paths.finance.transfers.root,
        resource: 'finance-transfer',
        action: 'read',
        icon: ICONS.withdraw,
        roles: ['*'],
      },
      {
        title: 'resource.financeAllowlist',
        path: paths.finance.allowlist.root,
        resource: 'finance-allowlist',
        action: 'read',
        icon: ICONS.roles,
        roles: ['*'],
      },
      {
        title: 'resource.financeLimits',
        path: paths.finance.limits.root,
        resource: 'finance-limits',
        action: 'read',
        icon: ICONS.settings,
        roles: ['*'],
      },
      {
        title: 'resource.turnkeyConfig',
        path: paths.finance.tunkeySetup.root,
        resource: 'turnkey-config',
        action: 'read',
        icon: ICONS.settings,
        roles: ['*'],
      },
    ],
  },

  // 08 · System Admin
  {
    subheader: 'resource.sectionSystemAdmin',
    items: [
      {
        title: 'resource.users',
        path: paths.dashboard.users.root,
        icon: ICONS.user,
        resource: 'users',
        action: 'read',
        roles: ['*'],
      },
      {
        title: 'resource.roles',
        path: paths.dashboard.roles.root,
        icon: ICONS.roles,
        resource: 'roles',
        action: 'read',
        roles: ['*'],
      },
      {
        title: 'resource.groups',
        path: paths.dashboard.groups.root,
        icon: ICONS.roles,
        resource: 'groups',
        action: 'read',
        roles: ['*'],
      },
      {
        title: 'resource.auditLogs',
        path: paths.auditLogs.list.root,
        icon: ICONS.file,
        resource: 'audit-logs',
        action: 'read',
        roles: ['*'],
      },
      {
        title: 'resource.notificationConfigs',
        path: paths.dashboard.notificationConfigs.root,
        resource: 'notification-configs',
        icon: ICONS.menuItem,
        action: 'read',
        roles: ['admin'],
      },
      {
        title: 'resource.appVersionManagement',
        path: paths.appVersionManagement.codes.root,
        resource: 'app-version-updates',
        icon: ICONS.menuItem,
        action: 'read',
        roles: ['*'],
      },
      {
        title: 'resource.turnkeyAddressSearch',
        path: paths.turnkeyAddressSearch.root,
        resource: 'turnkey-address-search',
        icon: ICONS.menuItem,
        action: 'read',
      },
      {
        title: 'resource.adminConfig',
        path: paths.dashboard.config.adminConfig.root,
        resource: 'admin-configs',
        icon: ICONS.menuItem,
        action: 'read',
      },
      {
        title: 'resource.rpc',
        path: paths.dashboard.systemRpc.root,
        resource: 'rpc',
        icon: ICONS.menuItem,
        action: 'read',
      },
      {
        title: 'resource.proxy',
        path: paths.dashboard.systemProxy.root,
        resource: 'proxy',
        icon: ICONS.menuItem,
        action: 'read',
      },
      {
        title: 'resource.maintenance',
        path: paths.dashboard.maintenance.root,
        resource: 'maintenance',
        icon: ICONS.menuItem,
        action: 'read',
      },
      {
        title: 'resource.crawlerMonitor',
        path: paths.dashboard.crawlerMonitor.root,
        resource: 'crawler-monitor',
        icon: ICONS.menuItem,
        action: 'read',
      },
      {
        title: 'resource.cronMonitor',
        path: paths.dashboard.cronMonitor.root,
        resource: 'cron-monitor',
        icon: ICONS.menuItem,
        action: 'read',
      },
      {
        title: 'resource.domainConfigs',
        path: paths.domainConfigs.codes.root,
        resource: 'domain-configs',
        icon: ICONS.menuItem,
        action: 'read',
      },
      {
        title: 'resource.proxyManager',
        path: paths.dashboard.proxyManager.root,
        resource: 'proxy-manager',
        icon: ICONS.menuItem,
        action: 'read',
      },
    ],
  },
];
